/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Prerequisite,
    PrerequisiteFromJSON,
    PrerequisiteFromJSONTyped,
    PrerequisiteToJSON,
    QuestConfigMilestone,
    QuestConfigMilestoneFromJSON,
    QuestConfigMilestoneFromJSONTyped,
    QuestConfigMilestoneToJSON,
    QuestDisplay,
    QuestDisplayFromJSON,
    QuestDisplayFromJSONTyped,
    QuestDisplayToJSON,
    QuestReset,
    QuestResetFromJSON,
    QuestResetFromJSONTyped,
    QuestResetToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuestConfigBody
 */
export interface QuestConfigBody {
    /**
     * 
     * @type {Array<QuestDisplay>}
     * @memberof QuestConfigBody
     */
    displayedOn?: Array<QuestDisplay>;
    /**
     * Display quest to users who have not yet met prerequisites.
     * @type {boolean}
     * @memberof QuestConfigBody
     */
    shouldDisplayUnqualified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfigBody
     */
    requireProgressionOrder?: boolean;
    /**
     * The title of the reward.
     * @type {string}
     * @memberof QuestConfigBody
     */
    name: string;
    /**
     * The description of the reward.
     * @type {string}
     * @memberof QuestConfigBody
     */
    description?: string;
    /**
     * If the quest is active (shows on FE and processes event logs in BE) or not.
     * @type {boolean}
     * @memberof QuestConfigBody
     */
    isActive: boolean;
    /**
     * If the quest complete notification should be shown.
     * @type {boolean}
     * @memberof QuestConfigBody
     */
    showQuestCompleteNotification?: boolean;
    /**
     * The message to show in the quest complete notification.
     * @type {string}
     * @memberof QuestConfigBody
     */
    questCompleteNotificationMessage?: string;
    /**
     * 
     * @type {QuestReset}
     * @memberof QuestConfigBody
     */
    questReset?: QuestReset;
    /**
     * 
     * @type {Array<QuestConfigMilestone>}
     * @memberof QuestConfigBody
     */
    milestones?: Array<QuestConfigMilestone>;
    /**
     * 
     * @type {Array<Prerequisite>}
     * @memberof QuestConfigBody
     */
    prerequisites?: Array<Prerequisite>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestConfigBody
     */
    rewardConfigIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfigBody
     */
    isSponsored?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigBody
     */
    sponsorName?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigBody
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigBody
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigBody
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigBody
     */
    rewardImage?: string;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigBody
     */
    startAt?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigBody
     */
    endAt?: number;
}

export function QuestConfigBodyFromJSON(json: any): QuestConfigBody {
    return QuestConfigBodyFromJSONTyped(json, false);
}

export function QuestConfigBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestConfigBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayedOn': !exists(json, 'displayedOn') ? undefined : ((json['displayedOn'] as Array<any>).map(QuestDisplayFromJSON)),
        'shouldDisplayUnqualified': !exists(json, 'shouldDisplayUnqualified') ? undefined : json['shouldDisplayUnqualified'],
        'requireProgressionOrder': !exists(json, 'requireProgressionOrder') ? undefined : json['requireProgressionOrder'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isActive': json['isActive'],
        'showQuestCompleteNotification': !exists(json, 'showQuestCompleteNotification') ? undefined : json['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': !exists(json, 'questCompleteNotificationMessage') ? undefined : json['questCompleteNotificationMessage'],
        'questReset': !exists(json, 'questReset') ? undefined : QuestResetFromJSON(json['questReset']),
        'milestones': !exists(json, 'milestones') ? undefined : ((json['milestones'] as Array<any>).map(QuestConfigMilestoneFromJSON)),
        'prerequisites': !exists(json, 'prerequisites') ? undefined : ((json['prerequisites'] as Array<any>).map(PrerequisiteFromJSON)),
        'rewardConfigIds': !exists(json, 'rewardConfigIds') ? undefined : json['rewardConfigIds'],
        'isSponsored': !exists(json, 'isSponsored') ? undefined : json['isSponsored'],
        'sponsorName': !exists(json, 'sponsorName') ? undefined : json['sponsorName'],
        'logo': !exists(json, 'logo') ? undefined : json['logo'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'externalUrl': !exists(json, 'externalUrl') ? undefined : json['externalUrl'],
        'rewardImage': !exists(json, 'rewardImage') ? undefined : json['rewardImage'],
        'startAt': !exists(json, 'startAt') ? undefined : json['startAt'],
        'endAt': !exists(json, 'endAt') ? undefined : json['endAt'],
    };
}

export function QuestConfigBodyToJSON(value?: QuestConfigBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayedOn': value.displayedOn === undefined ? undefined : ((value.displayedOn as Array<any>).map(QuestDisplayToJSON)),
        'shouldDisplayUnqualified': value.shouldDisplayUnqualified,
        'requireProgressionOrder': value.requireProgressionOrder,
        'name': value.name,
        'description': value.description,
        'isActive': value.isActive,
        'showQuestCompleteNotification': value.showQuestCompleteNotification,
        'questCompleteNotificationMessage': value.questCompleteNotificationMessage,
        'questReset': QuestResetToJSON(value.questReset),
        'milestones': value.milestones === undefined ? undefined : ((value.milestones as Array<any>).map(QuestConfigMilestoneToJSON)),
        'prerequisites': value.prerequisites === undefined ? undefined : ((value.prerequisites as Array<any>).map(PrerequisiteToJSON)),
        'rewardConfigIds': value.rewardConfigIds,
        'isSponsored': value.isSponsored,
        'sponsorName': value.sponsorName,
        'logo': value.logo,
        'color': value.color,
        'externalUrl': value.externalUrl,
        'rewardImage': value.rewardImage,
        'startAt': value.startAt,
        'endAt': value.endAt,
    };
}


